function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import featureEnabled from 'shared/helper/feature';
import { convertFormDataToFilesJson, convertJsonToSelectFieldValue, convertTimestampToDate } from './generics-conversion-service';
export var convertFormDataToDigitalEditUpdateRequest = function convertFormDataToDigitalEditUpdateRequest(data) {
  var request = {
    files: convertFormDataToFilesJson(data),
    styleOfEnglish: data.styleOfEnglish,
    origin: 'aje'
  };
  if (featureEnabled('rubriq_lewis_version') && data.version) {
    request.version = data.version;
  }
  return request;
};
export var convertJsonToFormData = function convertJsonToFormData(digitalPurchase) {
  return _objectSpread(_objectSpread({}, digitalPurchase), {}, {
    availablePurchaseIdentity: convertJsonToSelectFieldValue(digitalPurchase.availablePurchaseIdentity, {
      allowedLanguages: digitalPurchase.allowedLanguages,
      numberOfUsesAvailable: digitalPurchase.numberOfUsesAvailable,
      type: digitalPurchase.type
    })
  });
};
export var convertDigitalEditDisplayDetailsToJson = function convertDigitalEditDisplayDetailsToJson(json) {
  var availableDigitalPurchases = json.availableDigitalPurchases,
    endsAt = json.digitalPurchaseEndDate,
    digitalPurchases = json.digitalPurchases,
    hasDigitalEditingPurchase = json.hasDigitalEditingPurchase,
    hasUploadedDigitalEdit = json.hasUploadedDigitalEdit;
  var digitalEditingPurchase = endsAt ? {
    endsAt: endsAt
  } : null;
  return {
    availableDigitalPurchases: availableDigitalPurchases,
    digitalEditingPurchase: digitalEditingPurchase,
    digitalPurchases: digitalPurchases,
    hasDigitalEditingPurchase: hasDigitalEditingPurchase,
    hasUploadedDigitalEdit: hasUploadedDigitalEdit
  };
};
export var convertPaddleSubscriptionToJson = function convertPaddleSubscriptionToJson(paddleSubscription) {
  return {
    cancelUrl: paddleSubscription.cancelUrl,
    updateUrl: paddleSubscription.updateUrl,
    nextBillDate: convertTimestampToDate(paddleSubscription.nextBillDate),
    validThrough: convertTimestampToDate(paddleSubscription.validThrough)
  };
};
export var convertFormDataToDigitalPurchaseUpdateRequest = function convertFormDataToDigitalPurchaseUpdateRequest(formData) {
  var digitalPurchaseDetails = {
    allowedLanguages: formData.availablePurchaseIdentity.allowedLanguages,
    availablePurchaseIdentity: formData.availablePurchaseIdentity.value,
    endsAt: formData.endsAt.toISOString(),
    numberOfUsesAvailable: parseInt(formData.numberOfUsesAvailable, 10),
    preferredGroupCode: formData.preferredGroupCode,
    receiptCode: formData.receiptCode,
    startsAt: formData.startsAt.toISOString(),
    type: formData.availablePurchaseIdentity.type
  };
  return {
    digitalPurchaseDetails: digitalPurchaseDetails
  };
};